import { computed, makeObservable, observable } from 'mobx';
import { OrderApi } from './order-api';
import { PaymentApi } from '../payment/payment-api';

const CURRENCY_SYMBOLS: Record<string, string> = {
    TRY: '₺',
    RUB: '₽',
    USD: '$',
    EUR: '€',
    GBP: '£',
};

const CURRENCY_NAMES_RU: Record<string, string> = {
    TRY: 'лирах',
    RUB: 'рублях',
    USD: 'долларах',
    EUR: 'евро',
    GBP: 'фунтах',
};

export class OrderStore {
    @observable isLoaded = false;
    @observable shopName = '';
    @observable sberpayAvailable = false;
    @observable sbpAvailable = false;
    @observable currency = '';
    @observable error = '';
    @observable isSberPayProcess = false;
    @observable isSberPayError = false;

    constructor() {
        makeObservable(this);
    }

    @computed get currencySymbol(): string {
        return CURRENCY_SYMBOLS[this.currency] || this.currency;
    }

    @computed get amountPlaceholder(): string {
        const name = CURRENCY_NAMES_RU[this.currency];
        return name ? `Введите сумму в ${name}` : 'Введите сумму';
    }

    async getOrderInfo(qrCodeId: number) {
        try {
            const data = await OrderApi.getOrderInfo(qrCodeId);
            this.shopName = data.russian_trade_name;
            this.sberpayAvailable = data.sberpayAvailable;
            this.sbpAvailable = data.sbpAvailable;
            this.currency = data.qrCurrency || '';
            this.isLoaded = true;
        } catch (e) {
            this.error = 'Не удалось загрузить информацию о магазине';
            this.isLoaded = true;
        }
    }

    async createOrder(qrCodeId: number, amount: number): Promise<number | null> {
        try {
            const data = await OrderApi.createOrder({
                qrCodeId,
                amount,
                name: 'order',
                quantity: 1,
            });
            return data.idOrder;
        } catch (e) {
            this.error = 'Не удалось создать платёж';
            return null;
        }
    }

    async payWithSbp(idOrder: number): Promise<string | null> {
        try {
            const payment = await PaymentApi.getPayment(idOrder, window.location.href);
            return (payment as any).nspk_link || null;
        } catch (e) {
            this.error = 'Не удалось получить ссылку для оплаты';
            return null;
        }
    }

    async payWithSberPay(idOrder: number): Promise<string | null> {
        try {
            this.isSberPayProcess = true;
            this.isSberPayError = false;
            const payment = await PaymentApi.getPayment(idOrder, window.location.href, 'sberpay');
            return (payment as any).external_id || null;
        } catch (e) {
            this.isSberPayProcess = false;
            this.isSberPayError = true;
            this.error = 'SberPay недоступен, попробуйте позже';
            return null;
        }
    }
}
